/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ phase: NonNullable<unknown> }} Client_Contract_Phase_LabelInputs */

const en_client_contract_phase_label = /** @type {(inputs: Client_Contract_Phase_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.phase === "judicial") return /** @type {LocalizedString} */ (`Judicial`);
	if (i?.phase === "extrajudicial") return /** @type {LocalizedString} */ (`Extrajudicial`);
	return /** @type {LocalizedString} */ (`${i?.phase}`)
	
};

const pt_br2_client_contract_phase_label = /** @type {(inputs: Client_Contract_Phase_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.phase === "judicial") return /** @type {LocalizedString} */ (`Judicial`);
	if (i?.phase === "extrajudicial") return /** @type {LocalizedString} */ (`Extrajudicial`);
	return /** @type {LocalizedString} */ (`${i?.phase}`)
	
};

/**
* | phase | output |
* | --- | --- |
* | "judicial" | "Judicial" |
* | "extrajudicial" | "Extrajudicial" |
* | * | "{phase}" |
*
* @param {Client_Contract_Phase_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const client_contract_phase_label = /** @type {((inputs: Client_Contract_Phase_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Contract_Phase_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_contract_phase_label(inputs)
	return pt_br2_client_contract_phase_label(inputs)
});